<template>
  <div class="score-container">
    <transition name="slide-fade">
      <img v-show="iconVisible" :src="iconType" alt="Pronunciation result icon">
    </transition>
  </div>
</template>

<script>
import { CLEAR_SCORE, iconType } from "@/constants";
import { sleep } from "@/utils/functions";
export default {
  data() {
    return {
      iconVisible: false,
      iconType: iconType.CORRECT,
      iconSize: 1
    };
  },
  methods: {
    async showIcon(type, size, msEnter, msLeave) {
      this.iconType = type;
      this.iconSize = size;
      await sleep(msEnter || 500);
      this.iconVisible = true;
      await sleep(msLeave || 500);
      this.iconVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.score-container {
  @include centerer;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: scale(0.7);
  opacity: 0;
}
</style>
